  <template>
    <div  class="embed-conteudo has-text-centered" v-if='data' style="margin-top:30px;max-width:600px; margin:auto">
      <div class="title is-6 has-text-weight-bold"> Detalhes</div>
      <el-form ref="form" :model="data" label-width="200px">
        <el-form-item label="Título">
          <el-input v-model="data.titulo"></el-input>
        </el-form-item>
        <el-form-item label="Data do Curso">
          <el-date-picker type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione a data" v-model="data.data" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="Início das Incrições">
          <el-date-picker type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione a data" v-model="data.inscricoes_inicio" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="Fim das Incrições">
          <el-date-picker type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione a data" v-model="data.inscricoes_fim" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="Onde será o curso">
          <el-input v-model="data.local"></el-input>
        </el-form-item>
      </el-form>
      <div class="title is-6 has-text-weight-bold"> Descrição</div>
      <div class="subtitle is-6">
        <small><i>Adicione uma descrição resumida para a página principal.</i></small>
      </div>
      <textarea class="textarea" v-model="data.resumo" maxlength="200"  placeholder="Resumo"/>
      <div class="subtitle is-6">
        <small><i>Faltam {{resumo(data.resumo)}} caracteres</i></small>
      </div>
      <br />
      <div class="subtitle is-6">
        <small><i>Adicione uma descrição mais completa para o seu curso.</i></small>
      </div>
      <vue-editor v-model="data.descricao" placeholder='Adicione uma descrição ao seu curso.' :editorToolbar='customToolbar' ></vue-editor>
      <hr />
      <div style="text-align:right">
      <el-button-group>
        <el-button type="primary" size="small" @click='saveCurso'><i class="fas fa-save" ></i> Salvar Informações</el-button>
      </el-button-group>
    </div>
    </div>  
  </template>

  <script>
    import { VueEditor } from 'vue2-editor'
    import axios from 'axios';

    export default {
      props: ['data'],
      components: {
        VueEditor
      },
      data() {
         return {
          customToolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }] ],
          
         }
       },
      
      methods: {
        resumo(r){
          if(r != null ){
            return 200 - r.length ;
          }else{
            return 200;
          }
        },
        saveCurso(){
          const curso_id = this.$route.params.curso;
          global.Loading.begin(`Salvando dados do curso #${this.data.titulo}`);
          axios({
            method: 'post',
            url: `${global.base}/api/admin/curso/${curso_id}`,
            data: {
              dados: {
                titulo: this.data.titulo,
                inscricoes_inicio: this.data.inscricoes_inicio,
                inscricoes_fim: this.data.inscricoes_fim,
                data: this.data.data,
                local: this.data.local,
                descricao: this.data.descricao,
                resumo: this.data.resumo
              }
            },
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              global.Loading.end();
              this.curso = r.data;
            }).catch(()=>{
              global.Loading.end();
            })
        }
      }
    };
  </script>

  <style scoped>
    .embed-conteudo{
      padding:0px 0px;

    } 

  </style>